module.exports = __webpack_public_path__ + "img/new_3.22b8ce37.png";